import { Button, Flex, Form, Input, message, TreeSelect } from "antd";
import { useEffect, useState, useCallback } from "react";
import { fetchProduct } from "../Service/product";

const convertTreeData = (nodes = [], excludeId) =>
  nodes
    .filter(({ id }) => id !== excludeId)
    .map(({ id, productName, children }) => ({
      title: productName,
      value: id,
      key: id,
      children: children ? convertTreeData(children, excludeId) : undefined,
    }));

const ProductForm = ({ editData, isModalOpen, saveData }) => {
  const [form] = Form.useForm();
  const [productTree, setProductTree] = useState([]);

  /** ✅ Fetch product list with error handling */
  const fetchData = useCallback(async () => {
    try {
      const { data } = await fetchProduct();

      if (!Array.isArray(data)) {
        message.error("Invalid response format from server");
        return;
      }

      setProductTree(
        data.map((item) => ({
          ...item,
          key: item.id,
        }))
      );
    } catch {
      message.error("Failed to fetch products. Please try again.");
    }
  }, []);

  /** ✅ Populate form when editing */
  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        ...editData,
        parent: { id: editData.parentId ?? null },
      });
    } else {
      form.resetFields();
    }
  }, [editData, form]);

  /** ✅ Refresh product tree when modal opens */
  useEffect(() => {
    if (isModalOpen) fetchData();
  }, [isModalOpen, fetchData]);

  /** ✅ Handle form submission */
  // const handleSubmit = async (values) => {
  //   const payload = {
  //     ...values,
  //     parentId: values.parent?.id ?? null,
  //   };

  //   const success = await saveData(payload);
  //   if (success) {
  //     message.success("Product saved successfully");
  //     form.resetFields();
  //     fetchData();
  //   }
  // };

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
      parentId: values.parent?.id ?? null, // ✅ extract only the ID
    };

    delete payload.parent; // ✅ remove the 'parent' object entirely

    const success = await saveData(payload);
    if (success) {
      message.success("Product saved successfully");
      form.resetFields();
      fetchData();
    }
  };

  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      style={{ maxWidth: 600 }}
      onFinish={handleSubmit}
    >
      <Form.Item
        label="Product Name"
        name="productName"
        rules={[{ required: true, message: "Please input product name!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item label="Parent Product" name={["parent", "id"]}>
        <TreeSelect
          treeData={convertTreeData(productTree, editData?.id)}
          placeholder="Select Parent Product"
          allowClear
          treeDefaultExpandAll={false}
        />
      </Form.Item>

      <Flex justify="end">
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Flex>
    </Form>
  );
};

export default ProductForm;
